import { useState, useEffect } from "react";
import ReactGA from 'react-ga4';
import { Typography, Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PromptList from "./components/PrompList";
import PromptDialog from "./components/PromptDialog";

import requests from "../../utilities/requests";
import { toast } from "../../utilities/SnackBarUtils";

const Prompts = () => {
  const [prompts, setPrompts] = useState([]);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/prompts",
      title: "Prompts",
    });
  }, []);

  useEffect(() => {
    getPrompts();
  }, []);

  const getPrompts = async () => {
    const result = await requests("prompts");
    if (result.success) {
      setPrompts(result.prompts);
    }
  };

  const handleSelectPrompt = async (id) => {
    if (!id) {
      setSelectedPrompt(null);
      return;
    }

    const result = await requests(`prompts/?id=${id}`);
    if (result.success) {
      setSelectedPrompt(result.prompt);
      setDialogOpen(true);
    }
  };

  const handleMessage = (msg) => {
    if (!msg) {
        return
    }
    getPrompts();
    let message;
    if (msg === "create-success") {
        message = "Record created successfully";
    } else if (msg === "update-success") {
        message = "Record updated successfully."
    } else if (msg === "delete-success") {
        message = "Record deleted successfully"
    }
    toast.success(message);
  }

  return (
    <div
      style={{
        padding: 20,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 30,
      }}
    >
      <Typography variant="h5">Prompts</Typography>
      <PromptList
        prompts={prompts}
        handleSelect={(id) => handleSelectPrompt(id)}
      />
       <Fab
        color="primary"
        aria-label="add"
        style={{ position: "fixed", bottom: "5%", right: "5%" }}
        onClick={() => setDialogOpen(true)}
      >
        <AddIcon />
      </Fab>
      <PromptDialog
        prompt={selectedPrompt}
        open={dialogOpen}
        close={(msg) => {
          setDialogOpen(false);
          setSelectedPrompt(null);
          handleMessage(msg);
        }}
      />
    </div>
  );
};

export default Prompts;
